import Money from 'common/components/layout/Money';

import VariantTitle from './VariantTitle';

const SalePrice = (props) => {
  const { variant, settings, showVariantTitle } = props;
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice) {
    return null;
  }
  if (variant.addToCartPrice >= price) {
    return null;
  }
  // TODO change class name to be sale-price, make it bold, and font size needs to be at least the font size of retail price - c7-product__variant-sale-price
  return (
    <div className="c7-product__variant__price__sale">
      {variant.actionMessage}{' '}
      <Money number={variant.addToCartPrice} settings={settings} />{' '}
      {showVariantTitle && <VariantTitle variant={variant} />}
    </div>
  );
};

export default SalePrice;
